import React from 'react';
import './wheelloader.css';

class WheelLoader extends React.Component {
    render () {
        return (
          <div className='showbox'>
            <div className='loader'>
              <svg className='circular' viewBox='25 25 50 50'>
                <circle className='path' cx='50' cy='50' r='15' fill='none' strokeWidth='2.5' strokeMiterlimit='10' />
              </svg>
            </div>
          </div>
        );
    };
}

export default WheelLoader;



// WEBPACK FOOTER //
// ./src/components/wheelloader/WheelLoader.js